import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { accountTypePost } from "../../store/accountType/actions";
export var useAccountTypePost = function (trigger, body) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseAccountTypePost: (_a = state.AccountType.responseAccountTypePost) === null || _a === void 0 ? void 0 : _a.data,
            errorAccountTypePost: state.AccountType.errorAccountTypePost,
            loadingAccountTypePost: state.AccountType.loadingAccountTypePost,
        });
    }), responseAccountTypePost = _a.responseAccountTypePost, errorAccountTypePost = _a.errorAccountTypePost, loadingAccountTypePost = _a.loadingAccountTypePost;
    useEffect(function () {
        if (trigger) {
            dispatch(accountTypePost({
                clientId: body.data.clientId,
                description: body.data.description,
            }));
        }
    }, [trigger, body.data.clientId]);
    return {
        responseAccountTypePost: responseAccountTypePost,
        errorAccountTypePost: errorAccountTypePost,
        loadingAccountTypePost: loadingAccountTypePost,
    };
};
